import React, { useMemo } from 'react';
import cn from 'clsx';
import { Modal as FrontonModal, ModalProps as FrontonModalProps } from 'fronton-react';
import { curtainMobileModal, styledModal } from './modal-styles';

type ModalProps = {
  modalRef?: (el: HTMLDivElement) => void;
} & Omit<FrontonModalProps, 'ref'>

export const Modal: React.FC<ModalProps> = ({ children, className, modalRef, variant, ...rest }) => {
  const classNames = useMemo(() => (
    cn(styledModal, className, { [curtainMobileModal]: variant === 'curtain' })
  ), [className, variant]);

  return (
    <FrontonModal
      className={classNames}
      ref={modalRef}
      variant={variant}
      {...rest}
    >
      {children}
    </FrontonModal>
  );
};
